import axios from 'axios';
import { API } from 'config';
import { APIUtils } from 'commons/utils';

export const authenticate = (username: string, password: string, tfaToken?: string) => {
  const url = new URL('./auth', API.baseURL);
  return axios.post(url.toString(), { username, password, tfaToken }, APIUtils.apiKeyHeader());
};
